export default "__VITE_ASSET__746f65dd__"